<template lang="pug">
  .profile-page__main(
    v-if="requestData"
  )
    operator-modal(
      v-if="showOperatorModal"
      @close="showOperatorModal = false"
      :content="operatorModalContent"
      :on-submit-modal="submitModal"
    )
    .op-request
      .op-request__header
        .op-request__title.op-request-title
          .op-request-title__photo(
            v-bind:style="{ 'background-image': requestData.child.avatar[0] ? `url(${requestData.child.avatar[0].file})` : ''}"
          )
          .op-request-title__body
            .op-request-title__text
              h1.title Заявка №{{ requestId }}
            .op-request-title__status
              .status(
                :class="requestOrders[requestData.status].value"
              ) {{ requestOrders[requestData.status].text }}
        .op-request__info
          .op-request-info
            .op-request-info__item(
              v-for="item in campShiftItems"
            )
              .info-item
                .info-item__key {{ item.text }}
                .info-item__value {{ requestData.campshift[item.key] }}
      .op-request__body
        .op-request__tabs
          .tabs
            .tabs__item(
              v-for="tab in tabs"
              :key="tab.name"
            )
              .button(
                :class="{ 'button_paint-main': currentTab === tab.name }"
                @click="currentTab = tab.name"
              ) {{tab.text}}
        .op-request__form
          info-child(
            v-if="currentTab === 'child'"
            :data-profile="info.child"
            :request-data="requestData.child"
            :status="requestData.status"
            :on-change-accept-value="changeAcceptValue"
            :accept-list="acceptList"
            :awards="requestData.awards"
            :on-click-checkbox="clickCheckbox"
            :current-awards-points="currentAwardsPoints"
          )
          info-parent(
            v-else-if="currentTab === 'parent'"
            :data-profile="info.parent"
            :request-data="requestData.parent"
            :status="requestData.status"
            :on-change-accept-value="changeAcceptValue"
            :accept-list="acceptList"
          )
          section.profile-page-form__section.profile-section(
            v-if="requestData.status === 11"
          )
            .profile-section__title
              h2.profile-section-title Причины отклонения заявки
            .profile-section__body(
              v-if="requestData.comment.reject_type === '0'"
            )
              p Недействительные документы
              p {{ requestData.comment.comment }}
            .profile-section__body(
              v-if="requestData.comment.reject_type === '1'"
            )
              p Не прошла по рейтингу
            .profile-section__body(
              v-if="requestData.comment.reject_type === '2'"
            )
              p Другая причина
              p {{ requestData.comment.comment }}
          .profile-page-form
            section.profile-page-form__section.profile-section
              .profile-section__body
                .form
                  //- in work
                  .form__elem.form__elem_button(
                    v-if="requestData.status === 1"
                  )
                    .form-elem
                      .form-elem__body
                        .buttons-container
                          button.button.button_paint-main.button_long(
                            type="button"
                            @click="onChangeOrderStatus(2, 'in_work')"
                          )
                            .button__text Взять в работу
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                  //- accepted
                  .form__elem.form__elem_button(
                    v-if="requestData.status === 2"
                  )
                    .form-elem
                      .form-elem__body
                        button.button.button_long(
                          type="button"
                          @click.prevent="showOperatorModalFunc('operator-reject')"
                        )
                          .button__text Отклонить
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_long(
                          type="button"
                          @click.prevent="showOperatorModalFunc('operator-accept')"
                          :disabled="acceptListRequired.length < allowedAcceptList"
                          :title="acceptListRequired.length < allowedAcceptList ? 'Необходимо выбрать все чекбоксы' : ''"
                        )
                          .button__text Принять
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                  //- confirmed
                  .form__elem.form__elem_button(
                    v-if="requestData.status === 5"
                  )
                    //- .form-elem
                    //-   .form-elem__body
                    //-     button.button.button_long(
                    //-       type="button"
                    //-       @click.prevent="showOperatorModalFunc('operator-reject-docs')"
                    //-     )
                    //-       .button__text Отклонить
                    //-   .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_long(
                          type="button"
                          @click="onChangeOrderStatus(6, 'confirmed')"
                        )
                          .button__text Подтверждены
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                  //- end
                  .form__elem.form__elem_button(
                    v-if="requestData.status === 6"
                  )
                    .form-elem
                      .form-elem__body
                        button.button.button_long(
                          type="button"
                          @click="onPrint(12)"
                        )
                          .button__text Распечатать путевку
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_long(
                          type="button"
                          @click="onPrint(13)"
                        )
                          .button__text Распечатать инструкцию
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
                  //- rejected_by_operator
                  //- .form__elem.form__elem_button(
                  //-   v-if="requestData.status === 11"
                  //- )
                  //-   .form-elem
                  //-     .form-elem__body
                  //-       button.button.button_long(
                  //-         type="button"
                  //-       )
                  //-         .button__text Причины отказа
                  //-     .form-elem__error(v-show="showErrorInfo") Не все поля заполнены
</template>

<script>
import Vue from "vue";

import {mapState, mapActions} from "vuex";
import InfoChild from "../components/InfoChild";
import InfoParent from "../components/InfoParent";
import OperatorModal from "@/components/modals/OperatorModal";

export default {
  name: "OperatorCurrentRequest",
  components: {
    OperatorModal,
    InfoParent,
    InfoChild
  },
  data() {
    return {
      showErrorInfo: false,
      showOperatorModal: false,
      operatorModalContent: "",
      requestData: null,
      acceptList: [],
      acceptListRequired: [],
      allowedAcceptList: 8,
      campShiftItems: [
        {
          text: "Лагерь:",
          key: "camp_name"
        },
        {
          text: "Смена:",
          key: "name"
        },
        {
          text: "Даты:",
          key: "dates"
        },
        {
          text: "Дата подачи:",
          key: "date_created"
        }
      ],
      currentTab: "child",
      tabs: [
        {
          name: "child",
          text: "Анкета ребенка"
        },
        {
          name: "parent",
          text: "Анкета родителя"
        }
      ],
      info: {
        child: {
          main: [
            {
              type: "text",
              title: "Фамилия ребенка",
              key: "last_name"
            },
            {
              type: "text",
              title: "Имя ребенка",
              key: "first_name"
            },
            {
              type: "text",
              title: "Отчество ребенка",
              key: "fathers_name"
            },
            {
              type: "text",
              title: "Пол ребенка",
              key: "gender",
              short: true
            },
            {
              type: "date",
              title: "Дата рождения ребенка",
              key: "date_of_birth",
              short: true
            },
            {
              type: "text",
              title: "Гражданство",
              key: "nationality"
            }
          ],
          address: [
            {
              type: "text",
              title: "Район",
              key: "area"
            },
            {
              type: "text",
              title: "Город",
              key: "city"
            },
            {
              type: "text",
              title: "Улица",
              key: "street"
            },
            {
              type: "text",
              title: "Дом",
              key: "house"
            },
            {
              type: "text",
              title: "Квартира",
              key: "apartment"
            },
            {
              type: "text",
              title: "Индекс",
              key: "postal_code"
            }
          ],
          school: [
            {
              type: "text",
              title: "Регион",
              key: "region"
            },
            {
              type: "text",
              title: "Школа",
              key: "school"
            },
            {
              type: "text",
              title: "Класс",
              key: "class"
            },
            {
              type: "text",
              title: "Профиль класса",
              key: "class_profile"
            }
          ],
          awards: [
            {
              name: "Математика"
            },
            {
              name: "Ознакомьтесь с необходимыми документами которые необходимо"
            }
          ],
          docs: {
            passport: [
              {
                type: "text",
                title: "Тип удостоверения личности",
                key: "doc_type"
              },
              {
                type: "text",
                title: "Серия и номер",
                key: "passport"
              },
              {
                type: "date",
                title: "Дата выдачи",
                key: "passport_issue_date",
                short: true
              },
              {
                type: "file",
                title: "Копия",
                files: "passport_attachments",
                description: "Кем выдан, фото, прописка"
              },
              {
                type: "text",
                title: "СНИЛС",
                key: "snils"
              },
              {
                type: "file",
                title: "Копия СНИЛС",
                files: "snils_attachments"
              },
              {
                type: "text",
                title: "ИНН",
                key: "inn"
              },
              {
                type: "file",
                title: "Копия ИНН",
                files: "inn_attachments"
              }
            ],
            birth_certificate: [
              {
                type: "text",
                title: "Тип удостоверения личности",
                key: "doc_type"
              },
              {
                type: "text",
                title: "Серия и номер",
                key: "birth_certificate"
              },
              {
                type: "file",
                title: "Копия",
                files: "birth_certificate_attachments"
              }
            ]
          }
        },
        parent: {
          main: [
            {
              type: "text",
              title: "Фамилия",
              key: "last_name"
            },
            {
              type: "text",
              title: "Имя",
              key: "first_name"
            },
            {
              type: "text",
              title: "Отчество",
              key: "fathers_name"
            },
            {
              type: "text",
              title: "Пол",
              key: "gender",
              short: true
            },
            {
              type: "date",
              title: "Дата рождения",
              key: "date_of_birth",
              short: true
            }
          ],
          contacts: [
            {
              type: "text",
              title: "Адрес электронной почты",
              key: "email"
            },
            {
              type: "text",
              title: "Телефон",
              key: "phone"
            },
            {
              type: "text",
              title: "Рабочий телефон",
              key: "work_phone"
            }
          ],
          docs: [
            {
              type: "text",
              title: "СНИЛС",
              key: "snils"
            },
            {
              type: "text",
              title: "ИНН",
              key: "inn"
            },
            {
              type: "text",
              title: "Серия и номер паспорта",
              key: "passport"
            },
            {
              type: "date",
              title: "Дата выдачи паспорта",
              key: "passport_issue_date",
              short: true
            },
            {
              type: "file",
              title: "Копия паспорта",
              files: "passport_attachments"
            },
            {
              type: "file",
              title: "Другие документы",
              files: "another_documents"
            }
          ],
          address: [
            {
              type: "text",
              title: "Район",
              key: "area"
            },
            {
              type: "text",
              title: "Город",
              key: "city"
            },
            {
              type: "text",
              title: "Улица",
              key: "street"
            },
            {
              type: "text",
              title: "Дом",
              key: "house"
            },
            {
              type: "text",
              title: "Квартира",
              key: "apartment"
            },
            {
              type: "text",
              title: "Индекс",
              key: "postal_code"
            }
          ]
        }
      },
      currentAwardsPoints: 0
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    requestId() {
      return this.$route.params.requestId;
    },
    requestOrders() {
      return this.$store.getters.requestOrders();
    }
  },
  methods: {
    ...mapActions(["getOrder", "changeOrderStatus", "deleteOrderAwards"]),
    clickCheckbox(e, elem) {
      const checked = e.target.checked;
      this.requestData.awards = this.requestData.awards.map(award => {
        if (award.id === elem.id) {
          award.checked = checked;
        }
        return award;
      });
      const checkedElems = this.requestData.awards.filter(el => el.checked);
      if (checkedElems.length > 0 && this.acceptList.indexOf("child_4") < 0) {
        this.acceptList.push("child_4");
      } else if (checkedElems.length === 0) {
        this.acceptList = this.acceptList.filter(el => el !== "child_4");
      }
      if (elem.checked) {
        this.currentAwardsPoints += elem.points;
      } else {
        this.currentAwardsPoints -= elem.points;
      }
    },
    onPrint(type) {
      const doc = this.requestData.docs.find(el => el.attachment_type === type);
      const link = document.createElement("a");
      link.setAttribute("href", doc.file);
      link.setAttribute("target", "_blank");
      link.click();
    },
    //Эта функция для удаления неотмеченных наград!
    onDeleteOrderAwards() {
      this.requestData.awards.map(award => {
        if (!award.checked) {
          this.deleteOrderAwards({
            orderId: this.requestId,
            awardId: award.id
          });
        }
        return award;
      });
    },
    async submitModal(data, status) {
      const _data = {};
      _data.status = status;
      if (data.date_originals_deadline) {
        _data.date_originals_deadline = data.date_originals_deadline
          .split(".")
          .reverse()
          .join("-");
        delete data.date_originals_deadline;
      }
      _data.comment = JSON.stringify(data);
      if (status === 5 || status === 11) {
        await this.onDeleteOrderAwards();
      }
      this.changeOrderStatus({
        id: this.requestId,
        data: _data
      }).then(res => {
        if (res.status === 200) {
          this.$root.$emit("onShowNotificationModal", {
            text: `Заявка переведена в статус<br>'${
              this.requestOrders[status].text
            }'`
          });
          this.requestData = this.onBuildRequestData(res.data);
        }
      });
    },
    changeAcceptValue(e, type) {
      if (e.target.checked) {
        this.acceptList.push(type);
        this.acceptListRequired.push(type);
      } else {
        this.acceptList = this.acceptList.filter(el => el !== type);
        this.acceptListRequired = this.acceptList;
      }
    },
    showOperatorModalFunc: function(content) {
      this.operatorModalContent = content;
      this.showOperatorModal = true;
    },
    onChangeOrderStatus(status) {
      this.changeOrderStatus({
        id: this.requestId,
        data: {
          status: status
        }
      }).then(res => {
        if (res.status === 200) {
          this.$root.$emit("onShowNotificationModal", {
            text: `Заявка переведена в статус<br>'${
              this.requestOrders[status].text
            }'`
          });
          this.requestData = this.onBuildRequestData(res.data);
        }
      });
    },
    onBuildRequestData(data) {
      const requestData = JSON.parse(JSON.stringify(data));
      requestData.awards = requestData.awards.map(award => {
        award.checked = false;
        return award;
      });
      requestData.comment = requestData.comment
        ? JSON.parse(requestData.comment)
        : "";
      requestData.campshift.date_created = new Date(
        requestData.date_created
      ).toLocaleDateString("ru");
      const dateStart = Vue.filter("monthDayDate")(
        requestData.campshift.date_started
      );
      const dateEnd = Vue.filter("monthDayDate")(
        requestData.campshift.date_finished
      );
      requestData.campshift.dates = `${dateStart} - ${dateEnd}`;
      // child
      requestData.child.docType =
        requestData.child.passport.length > 0
          ? "passport"
          : "birth_certificate";
      requestData.child.doc_type =
        requestData.child.docType === "passport"
          ? "Паспорт"
          : "Свидетельство о рождении";
      requestData.child.gender = requestData.child.gender
        ? "Девочка"
        : "Мальчик";
      // parent
      requestData.parent.gender = requestData.parent.gender
        ? "Женщина"
        : "Мужчина";
      return requestData;
    }
  },
  mounted() {
    this.getOrder(this.requestId).then(requestData => {
      this.requestData = this.onBuildRequestData(requestData);
    });
  }
};
</script>
